/**
 * Husleie.no API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0
 * Contact: devops+api@husleie.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import DefaultErrorResponseScheme from '../model/DefaultErrorResponseScheme';
import InlineObject13 from '../model/InlineObject13';
import InlineObject14 from '../model/InlineObject14';
import InlineResponse20016 from '../model/InlineResponse20016';
import InlineResponse20017 from '../model/InlineResponse20017';
import InlineResponse20018 from '../model/InlineResponse20018';

/**
 * Product service.
 * @module api/ProductApi
 * @version 1.0
 */
export default class ProductApi {

    /**
     * Constructs a new ProductApi. 
     * @alias module:api/ProductApi
     * @class
     * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
     * default to {@link module:ApiClient#instance} if unspecified.
     */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createDepositAccount operation.
     * @callback module:api/ProductApi~createDepositAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse20016} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Sets up the required structur to create a deposit account
     * Creates a new datastructure to enable a tenant to create a new deposit account with out partner.
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject13} opts.depositAccount 
     * @param {module:api/ProductApi~createDepositAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse20016}
     */
    createDepositAccount(opts, callback) {
        opts = opts || {};
        let postBody = opts['depositAccount'];


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse20016;

        return this.apiClient.callApi(
            '/product/deposit_account', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the depositAccountError operation.
     * @callback module:api/ProductApi~depositAccountErrorCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse20018} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Handels errors reported back from partner
     * Handels errors, and recreateds a new deposit account request for the user to try again.
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject14} opts.depositAccountError 
     * @param {module:api/ProductApi~depositAccountErrorCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse20018}
     */
    depositAccountError(id, opts, callback) {
        opts = opts || {};
        let postBody = opts['depositAccountError'];

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling depositAccountError");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse20018;

        return this.apiClient.callApi(
            '/product/deposit_accounti/{id}/error', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the getDepositAccount operation.
     * @callback module:api/ProductApi~getDepositAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse20017} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns the url needed for the tenant to sign the deposti account
     * Returns the url needed for the tenant to sign the deposti account
     * @param {String} id 
     * @param {module:api/ProductApi~getDepositAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse20017}
     */
    getDepositAccount(id, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling getDepositAccount");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse20017;

        return this.apiClient.callApi(
            '/product/deposit_account/{id}', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the handleDepositAccountCallback operation.
     * @callback module:api/ProductApi~handleDepositAccountCallbackCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Handels callbacks from signing partner on deposit account signing
     * This will handle callbacks from signing partner when the user has performed a action on the signing request. This should not be called from a HusleieAPI client directly
     * @param {String} id 
     * @param {String} event 
     * @param {module:api/ProductApi~handleDepositAccountCallbackCallback} callback The callback function, accepting three arguments: error, data, response
     */
    handleDepositAccountCallback(id, event, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling handleDepositAccountCallback");
        }

        // verify the required parameter 'event' is set
        if (event === undefined || event === null) {
            throw new Error("Missing the required parameter 'event' when calling handleDepositAccountCallback");
        }


        let pathParams = {
            'id': id,
            'event': event
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = [];
        let returnType = null;

        return this.apiClient.callApi(
            '/product/deposit_account/{id}/callback/{event}', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }


}